module.exports = __webpack_public_path__ + "static/media/ic-streaming-mic-dark.b8d64e28.svg";